import {LogCat, LogManager} from "../../../common/log";
import {AddressList} from "./address";
import {IAddressEntry} from "..";
import {IUserContextData, IUserContextPartialData} from "..";
import {Person} from "../../person.resource";
import {IUserPreferences} from "../interfaces/Iuser.preferences";
import {IResourceRole} from "../interfaces/Iresource.role";
import {PopupsPositions} from "../../../common/ui/components/popup/popup.component/popup.position.store";

//@Injectable()
export class UserContext implements IUserContextData {
	public userId: string;
	public roleGroupKey: number;
	public groupKeys: number[];
	public groupWorkstationLock:number[];
	public resourceIdKey: number;
	public defaultResourceIdKey: number;
	public resourceIdKeys: number[];
	public defaultModalityScheduleGroupKey: number;
	public modalityScheduleGroupKeys: number[];
	public fileSchema: number;
	public userPersonKey: number;
	public firstName: string;
	public lastName: string;
	public middleName: string;
	public namePrefix: string;
	public currentOrganization: number;
	public defaultLangKey: number;
	public registeredLocationKey: number;
	public defaultPatientClassKey: number;
	public orderingOrganizationKey: number;

	public addressList: AddressList;
	public resourceRoleList: IResourceRole[];

	public personResource: Person;

	public userPreferences: IUserPreferences;
	public passwordExpirationDaysLeft: number;
	public popupPosition:PopupsPositions|Object;

	public constructor(userContext?: IUserContextData) {
		LogManager.debug(LogCat.RisUserContextCategories.General, "User context created.", userContext);
		this.addressList = new AddressList();

		if (userContext) {
			this.setContext(userContext);
		}
		Object.freeze(this);
	}

	/**
	* Adds an address to the address array of the user context.
	* @param address The address to be added.
	*/
	public addAddress(address: IAddressEntry): void {
		this.addressList.addAddress(address);
	}

	/**
	* Gets the primary address of the user.
	* @param none
	* @returns An AddressEntry object containing the user's primary address.
	*/
	public get primaryAddress(): IAddressEntry {

		return this.addressList.primaryAddress;
	}

	/**
	* Set the context info to match the received IUserContext.
	* @param fields An IUserContext containing user context data.
	* @returns void
	*/
	public setContext(context: IUserContextData): void {
		LogManager.debug(LogCat.RisUserContextCategories.General, "Set user context fields.", context);

		this.userId = context.userId ? context.userId : null;
		this.roleGroupKey = context.roleGroupKey ? context.roleGroupKey : null;
		this.groupKeys = context.groupKeys ? context.groupKeys : null;
		this.groupWorkstationLock = context.groupWorkstationLock ? context.groupWorkstationLock: null;
		this.defaultResourceIdKey = context.defaultResourceIdKey ? context.defaultResourceIdKey : null;
		this.resourceIdKey = context.resourceIdKey ? context.resourceIdKey : context.defaultResourceIdKey ? context.defaultResourceIdKey : null;
		this.resourceIdKeys = context.resourceIdKeys ? context.resourceIdKeys : null;
		this.defaultModalityScheduleGroupKey = context.defaultModalityScheduleGroupKey ? context.defaultModalityScheduleGroupKey : null;
		this.modalityScheduleGroupKeys = context.modalityScheduleGroupKeys ? context.modalityScheduleGroupKeys : null;
		this.fileSchema = context.fileSchema ? context.fileSchema : null;
		this.userPersonKey = context.userPersonKey ? context.userPersonKey : null;
		this.firstName = context.firstName ? context.firstName : null;
		this.lastName = context.lastName ? context.lastName : null;
		this.middleName = context.middleName ? context.middleName : null;
		this.namePrefix = context.namePrefix ? context.namePrefix : null;
		this.currentOrganization = context.currentOrganization ? context.currentOrganization : null;
		this.defaultLangKey = context.defaultLangKey ? context.defaultLangKey : null;
		this.registeredLocationKey = context.registeredLocationKey ? context.registeredLocationKey : null;
		this.defaultPatientClassKey = context.defaultPatientClassKey ? context.defaultPatientClassKey : null;
		this.orderingOrganizationKey = context.orderingOrganizationKey ? context.orderingOrganizationKey : null;
		this.personResource = context.personResource ? context.personResource : null;
		this.userPreferences = context.userPreferences ? context.userPreferences: null;
		this.resourceRoleList = context.resourceRoleList;
		this.passwordExpirationDaysLeft = context.passwordExpirationDaysLeft;
		this.popupPosition = context.userPreferences.popupPosition;

		context.addressList.forEach((addressEntry: IAddressEntry) => {
			this.addressList.push(addressEntry);
		});
	}

	/**
	 * Creates a new context from the current context, substituting in the fields supplied in the received IUserContext.
	 * @param fields An IUserContext containing user context data.
	 * @returns void
	 */
	public updateContext(context: IUserContextPartialData): UserContext {
		return new UserContext(Object.assign({}, this, context));
	}
}

